// Sürükleme/resize sırasında hizalama kılavuz çizgileri (snap noktalarında).
// guides: [{axis:'x'|'y', pos:mm}] — yazdırılabilir alana göre (printable-relative).
export function SmartGuides({ guides, mmToPx, widthPx, heightPx }) {
  if (!guides || !guides.length) return null;
  return (
    <div style={{ position: 'absolute', left: 0, top: 0, width: widthPx, height: heightPx, pointerEvents: 'none', zIndex: 5 }}>
      {guides.map((g, i) => (g.axis === 'x' ? (
        <div key={i} style={{ position: 'absolute', left: mmToPx(g.pos), top: 0, width: 1, height: '100%', background: 'var(--designer-guide)' }} />
      ) : (
        <div key={i} style={{ position: 'absolute', top: mmToPx(g.pos), left: 0, height: 1, width: '100%', background: 'var(--designer-guide)' }} />
      )))}
    </div>
  );
}
